import { encryptAesGcm, stripKeyPrefix } from '@/infra/crypto/core'
import type { EncryptedPayload } from './types'

export const encryptField = async (
  data: string | Record<string, unknown>,
  key: string,
  keyVersion: number,
): Promise<EncryptedPayload> => {
  const plaintext = typeof data === 'string' ? data : JSON.stringify(data)
  const encoder = new TextEncoder()
  const plaintextBytes = encoder.encode(plaintext)

  const rawKey = stripKeyPrefix(key)
  const { ciphertext, iv } = await encryptAesGcm(plaintextBytes, rawKey)

  return {
    encrypted: true,
    algorithm: 'AES-256-GCM',
    keyVersion,
    ciphertext,
    iv,
  }
}
